angular.module('app').filter('background', function(AppService) {
    return function(src,location) {
    	if(!src || !location) return src;
    	var pattern = /\{\{location\.background\}\}/gim;
    	var result = pattern.exec(src);
    	var trace = angular.trace;
    	var device = AppService.device;
    	if(!result) return src;

    	return location.background ?  ((device ? "mobile/":"") + location.background) : null;
    };
});